import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "w-full flex flex-wrap sm:justify-between items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "h-4 w-4 mr-2",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Lisa ülesvõte ")
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "align-middle inline-block min-w-full" }
const _hoisted_7 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-md" }
const _hoisted_8 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Ülesvõtte nimetus "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Sekundid "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    }, " Doosikiirgus "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "relative px-6 py-3"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Kustuta")
    ])
  ])
], -1)
const _hoisted_10 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_11 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }
const _hoisted_12 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_14 = { class: "px-6 py-4 whitespace-nowrap text-right text-sm font-medium" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XRayImagesDropdown = _resolveComponent("XRayImagesDropdown")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_ButtonAdd = _resolveComponent("ButtonAdd")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_XRayImagesDropdown, {
        class: "w-full sm:w-1/4 my-2.5 sm:pr-3 md:pr-0",
        "image-name": _ctx.currentImageName,
        onOnImage: _cache[0] || (_cache[0] = (e) => (_ctx.currentImageName = e))
      }, null, 8, ["image-name"]),
      _createVNode(_component_InputField, {
        class: "w-full sm:w-1/4 my-2.5 sm:pl-3 md:pl-0",
        label: "Sekundid",
        isAutocomplete: false,
        fieldId: "equipmentModel",
        "input-type": _ctx.InputFieldType.NUMBER,
        value: _ctx.currentImageSecondsRate,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentImageSecondsRate) = $event))
      }, null, 8, ["input-type", "value"]),
      _createVNode(_component_InputField, {
        class: "w-full sm:w-1/4 my-2.5 sm:pl-3 md:pl-0",
        label: "Doosikiirus",
        isAutocomplete: false,
        fieldId: "equipmentModel",
        "input-type": _ctx.InputFieldType.NUMBER,
        value: _ctx.currentImageDoseRate,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentImageDoseRate) = $event))
      }, null, 8, ["input-type", "value"]),
      _createVNode(_component_ButtonAdd, {
        class: "my-2.5 sm:w-auto sm:ml-3 md:ml-0 flex items-center whitespace-nowrap",
        small: true,
        disabled: !_ctx.isCurrentImageValid,
        onClick: _withModifiers(_ctx.onAddImage, ["prevent"])
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.images.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("tbody", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, i) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `xray-image-${i}`
                          }, [
                            _createElementVNode("td", _hoisted_11, _toDisplayString(image.imageName), 1),
                            _createElementVNode("td", _hoisted_12, _toDisplayString(image.secondsRate), 1),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(image.doseRate), 1),
                            _createElementVNode("td", _hoisted_14, [
                              _createElementVNode("div", {
                                class: "text-blue-600 hover:text-blue-900 cursor-pointer transition duration-500 ease-in-out",
                                onClick: ($event: any) => (_ctx.removeImage(i))
                              }, " Kustuta ", 8, _hoisted_15)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}